// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLink_container__3TXwS","sending":"FooterLink_sending__1VwoX"};